export default function SowAssemptionIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#D1EFFF" />
      <path
        d="M12.0003 8.66699C10.1594 8.66699 8.66699 10.1594 8.66699 12.0003C8.66699 12.9079 9.02967 13.7307 9.618 14.3318C9.84716 14.5659 10.0355 14.8445 10.0998 15.1658L10.4525 16.9286C10.5772 17.5518 11.1245 18.0003 11.76 18.0003H12.2407C12.8762 18.0003 13.4234 17.5518 13.5481 16.9286L13.9009 15.1658C13.9651 14.8445 14.1535 14.5659 14.3827 14.3318C14.971 13.7307 15.3337 12.9079 15.3337 12.0003C15.3337 10.1594 13.8413 8.66699 12.0003 8.66699Z"
        stroke="#0070F2"
        stroke-width="1.5"
      />
      <path
        d="M12 6.66667V6"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 7.99967L16.6667 7.33301"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.333 12H17.9997"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 12H6"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33301 7.33301L7.99967 7.99967"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.667 15.333H13.3337"
        stroke="#0070F2"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
